/**
 * Default payload of the Minha Lais settings form.
 *
 * A factory (not a shared literal) so every mount starts from a clean object
 * before `LaisSettingsAPI.get()` merges the persisted values on top.
 */
export const createMinhaLaisSettingsForm = () => ({
  // Atendimento
  janela_continuidade_dias: 30,
  horario_inicio: '09:00',
  horario_fim: '18:00',
  dias_semana: ['seg', 'ter', 'qua', 'qui', 'sex'],
  pre_agendamento_ativo: false,
  funcao_solicitar_visita: true,
  pre_agendamento_antecedencia_horas: 2,
  pre_agendamento_janela_dias: 14,
  pre_agendamento_intervalo_minutos: 30,
  pre_agendamento_dias_semana: ['seg', 'ter', 'qua', 'qui', 'sex'],
  pre_agendamento_operacoes: ['venda', 'aluguel'],
  pre_agendamento_mensagem:
    'Temos alguns horários disponíveis para sua visita. Escolha a melhor opção e a Lais confirma tudo com o corretor.',
  lembrete_visita_antecedencia_dias: 1,
  lembrete_visita_dia_horas: 2,
  recesso_ativo: false,
  recesso_mensagem: 'Estamos em recesso. Retornaremos no próximo dia útil.',
  recesso_datas: '',
  // IA
  reengajamento_ativo: true,
  reengajamento_dias: 7,
  // Origens aceitas (como na Lais real: WhatsApp, Site Próprio, Plug Imóveis, etc.)
  origens_aceitas: [
    'whatsapp',
    'site_proprio',
    'plug_imoveis',
    'chaves_na_mao',
  ],
  tenant_service_fee_percent: 10,
});
